import { z } from "zod";

export const mediaAssetSchema = z
  .object({
    id: z.string(),
    key: z.string(),
    /** Public URL served via the public CloudFront distribution (/media/<key>). */
    url: z.string(),
    filename: z.string(),
    contentType: z.string(),
    size: z.number().int().nonnegative(),
    width: z.number().int().positive().nullable(),
    height: z.number().int().positive().nullable(),
    createdAt: z.string(),
    uploadedBy: z.string().nullable(),
  })
  .strict();
export type MediaAsset = z.infer<typeof mediaAssetSchema>;

export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024; // 50 MB

export const presignInputSchema = z
  .object({
    filename: z.string().min(1).max(255),
    contentType: z.string().min(1).max(255),
    size: z.number().int().positive().max(MAX_UPLOAD_BYTES),
  })
  .strict();
export type PresignInput = z.infer<typeof presignInputSchema>;

export const presignResponseSchema = z
  .object({
    mediaId: z.string(),
    key: z.string(),
    uploadUrl: z.string(),
    publicUrl: z.string(),
  })
  .strict();
export type PresignResponse = z.infer<typeof presignResponseSchema>;
